module.exports = __webpack_public_path__ + "static/media/parceiro(11).9904a22b.png";